<template>
  <v-row no-gutters>
    <v-col
      cols="12"
      sm="12"
      md="6"
      lg="4"
      v-if="props.shop.feature_enable.class_event"
    >
      <dashboard-quick-link
        title="งานต้อนรับนักเรียน"
        description="สำหรับต้อนรับลูกค้า Classroom"
        :to="{ name: 'frontdeskClassroomWelcome' }"
        icon="mdi-human-male-board"
      />
    </v-col>
    <v-col
      cols="12"
      sm="12"
      md="6"
      lg="4"
      v-if="props.shop.feature_enable.facility_event"
    >
      <dashboard-quick-link
        title="งานต้อนรับใช้สนาม"
        description="สำหรับต้อนรับลูกค้า Facility"
        :to="{ name: 'frontdeskFacilityWelcome' }"
        icon="mdi-land-plots"
      />
    </v-col>
    <v-col
      cols="12"
      sm="12"
      md="6"
      lg="4"
      v-if="props.shop.feature_enable.facility_event"
    >
      <dashboard-quick-link
        title="ตารางการใช้สนาม"
        description="สำหรับดูตารางการใช้งานสนาม"
        :to="{ name: 'frontdeskFacilitySchedule' }"
        icon="mdi-land-plots"
      />
    </v-col>
    <v-col
      cols="12"
      sm="12"
      md="6"
      lg="4"
      v-if="props.shop.feature_enable.open_private_event"
    >
      <dashboard-quick-link
        title="งานต้อนรับบริการ Open Private"
        description="สำหรับต้อนรับลูกค้า Open Private"
        :to="{ name: 'frontdeskOpenPrivateWelcome' }"
        icon="mdi-lock-open-outline"
      />
    </v-col>
    <v-col cols="12" sm="12" md="6" lg="4" v-if="hasUpdateFund">
      <dashboard-quick-link
        title="งานด้านสมาชิก"
        description="ให้บริการสมาชิกปัจจุบัน"
        :to="{ name: 'frontdeskMembership' }"
        icon="mdi-wallet-membership"
      />
    </v-col>
  </v-row>
</template>

<script setup>
import DashboardQuickLink from "@/components/frontdesk/DashboardQuickLink.vue";
import { defineProps, computed } from "vue";

const props = defineProps(["shop", "userProfile"]);

const hasUpdateFund = computed(() => {
  const shopId = props.shop?.shop_id || props.userProfile?.currentShopId;
  if (!shopId) return false;
  const roles = props.userProfile?.shopRole?.[shopId] || [];
  return roles.includes("update_fund");
});
</script>
